import { UserFunnelStatus, UserI } from "@/types/base";
import $api from "@/api/index";

export async function getUser(): Promise<UserI> {
  const response = await $api.get<{ data: UserI }>(`/v2/users/user`);

  return response.data.data;
}

export interface DcSyncResponse {
  updated_fields: Partial<UserI>;
}

export async function syncDcUser(): Promise<DcSyncResponse> {
  const response = await $api.post<DcSyncResponse>("/v2/users/dc-sync");

  return response.data;
}

export async function changeUserHexGroupId({
  hexGroupId,
}: {
  hexGroupId: number;
}): Promise<UserI> {
  const response = await $api.patch("/v2/users/user", {
    hexgroup_id: hexGroupId,
  });

  return response.data;
}

export async function changeUserAgglomerationId({
  agglomerationId,
}: {
  agglomerationId: number;
}): Promise<UserI> {
  const response = await $api.patch("/v2/users/user", {
    agglomeration_id: agglomerationId,
  });

  return response.data;
}

export async function setUserEmail({ mail }: { mail: string }): Promise<void> {
  const response = await $api.patch("/v2/users/user", {
    mail,
  });

  return response.data;
}

export async function setUserStatus({
  status,
}: {
  status: UserFunnelStatus;
}): Promise<UserI> {
  const response = await $api.patch("/v2/users/user", {
    status,
  });

  return response.data;
}

export async function setUserAppVersion({
  app_version,
}: {
  app_version: string;
}): Promise<UserI> {
  const response = await $api.patch("/v2/users/user", {
    app_version,
  });

  return response.data;
}

interface GetAwardedBonusesResponse {
  status: string;
  data: {
    text: string;
  };
}

export async function getAwardedBonuses(telegram_id: number) {
  const response = await $api.get<GetAwardedBonusesResponse>(
    "/v2/promo/promo-event-message-by-telegram-id",
    {
      params: { telegram_id },
    }
  );

  return response.data;
}

interface GetOrdersCountResponse {
  status: string;
  last_30_days_orders_completed_count: number;
}

export async function getOrdersCount(telegram_id: number) {
  const response = await $api.get<GetOrdersCountResponse>(
    "/v2/users/last_30_days_orders_count",
    {
      params: { telegram_id },
    }
  );

  return response.data;
}

export async function setActivateOption(params: {
  telegram_id: number;
  option: string;
}) {
  const response = await $api.patch(
    "/v2/subscriptions/change-selected-activate-option",
    params
  );

  return response.data;
}

export async function setPaymentMethod(params: { payment_method_id: string }) {
  const response = await $api.post(
    "/v2/subscriptions/payments/select-method",
    params
  );

  return response.data;
}

export async function setUserPromocode({
  promocode,
}: {
  promocode: string | null;
}) {
  const response = await $api.post("/v2/users/promocode", {
    promocode,
  });

  return response.data;
}

export async function deletePaymentMethod(params: {
  payment_method_id: string;
}) {
  const response = await $api.post(
    "/v2/subscriptions/payments/deactivate-method",
    params
  );

  return response.data;
}

export async function getWasSubscribePayed(telegram_id: number) {
  const response = await $api.get<{ data: boolean }>(
    "/v2/subscriptions/was-subscribe-payed",
    {
      params: { telegram_id },
    }
  );

  return response.data.data;
}

export interface ActivatePromoResponse {
  status: string;
  promo_code: string;
  days: number;
  applied: boolean;
  subscription_ends_at?: string | null;
}

export async function activatePromo(code: string) {
  const response = await $api.post<ActivatePromoResponse>(
    "/v2/subscriptions/activate-promo",
    {
      code,
    }
  );

  return response.data;
}
